module.exports = __webpack_public_path__ + "img/lianxi.a682aa36.png";